import { defineStore } from 'pinia'

export default defineStore('modal', {
  state: () => ({
    isOpen: false,
    type: 'info',
    message: ''
  }),
  actions: {
    openModal(modalType = 'info', msg = '') {
      this.type = modalType;
      this.message = msg;
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
    }
  }
})
